import React, { useEffect, useState } from "react";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import { getNotification } from "../../api/admin/notificationApi";

const InfoBarAdmin = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const fetchNotifications = async () => {
      try {
        const res = await getNotification();
        if (!mounted) return;
        const list = Array.isArray(res?.data) ? res.data : [];
        const active = list.filter(
          (n) =>
            n?.status === "Active" ||
            n?.status === "ACTIVE" ||
            n?.isActive === true
        );
        setNotifications(active);
      } catch {
        if (mounted) setNotifications([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchNotifications();
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div
        className="ds-alert ds-alert-info"
        style={{ height: 40, opacity: 0.5 }}
      />
    );
  }

  if (!notifications.length) return null;

  const text = notifications
    .map((n) => n.notification || n.message || n.title)
    .filter(Boolean)
    .join("  •  ");

  return (
    <div className="ds-alert ds-alert-info flex items-center gap-2 py-2">
      <CampaignOutlinedIcon
        fontSize="small"
        sx={{ color: "var(--primary-color)", flexShrink: 0 }}
      />
      <p
        className="m-0 text-[13px] font-medium text-[var(--text-dark)] truncate"
        title={text}
      >
        {text}
      </p>
    </div>
  );
};

export default InfoBarAdmin;
